var lib_core = require("lib-core");

var TrayAssetSearchTabView         = require("./trayAssetSearchTabView.js");
var TrayAssetSearchTabModel        = require("./trayAssetSearchTabModel.js");
var TrayAssetSearchTabStateMachine = require("./trayAssetSearchTabStateMachine.js");
var TrayTabsController = require('./../tray_tabs/trayTabsController.js');
var ProcessMessageController = require('./../processMessage/processMessageController.js');

var TrayAssetSearchTabController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UI_TRAY_TAB_SORT: {id: 'ui_tray_tab_01', name: "UI_TRAY_TAB_SORT" },
        UI_TRAY_TAB_SEARCH: {id: 'ui_tray_tab_02', name: "UI_TRAY_TAB_SEARCH" },
        UI_TRAY_TAB_TEMPLATE_CHANGE: {id: 'ui_tray_tab_03', name: "UI_TRAY_TAB_TEMPLATE_CHANGE" },
        OPEN_URL_IN_NEW_WINDOW: {id: 'ui_tray_tab_05', name: "OPEN_URL_IN_NEW_WINDOW" }
    });

};
lib_core.inherit(TrayAssetSearchTabController, lib_core.Controller);


TrayAssetSearchTabController.inject = {
    trayTabsController : TrayTabsController,
    userController : lib_core.UserController
};

TrayAssetSearchTabController.deject = {
    processingController : ProcessMessageController
};



module.exports = TrayAssetSearchTabController;

TrayAssetSearchTabController.prototype.beforeLoad = function() {
    var self = this;
    // Store config options in model
    this.getModel().name(this.name() || "");
    this.getModel().title(this.configuration.title || "");
    this.getModel().template(this.configuration.template || "");
    this.getModel().library(this.configuration.library || false);
    this.getModel().alternative_template(this.configuration.alternative_template || false);

    var query = {};

    // if we want to show things in my hub
    if(this.configuration.showHubAssets){
        // (this is the hub tray)
        if(this.configuration.useHub){
            query["hub"] = this.configuration.useHub;

        // if no hub is provided for hub tray, try and use root assets hub
        } else if(this.root.asset && this.root.asset.hub) {
            query["hub"] = this.root.asset.hub;
        } else {
            // if there is no hub,
            // and no asset provided,
            // then what we want is to show data from all of my hubs.
            // as a temporary solution, we will say 'private=true'
            // to filter out all the public assets,
            // but what we really want to do is filter out public assets
            // in hubs not owned by me.
            query["private"] = true; 
        }
    }

    // if we want to show public things
    if(this.configuration.showPublicAssets){
        query["private"] = false; 
    }

    // require a version unless isUnversioned.
    // with removal of collab service we no longer have the popup to
    // make a new version, so we should never show something without a version
    // (unless versions don't exist, like with models)
    if(!this.configuration.isUnversioned){
        query["hasVersions"] = 1;
    }

    
    this.getModel().default_query_fields(query);
    this.getModel().url(this.configuration.url || "");
    this.getModel().noSearch(this.configuration.noSearch || false);

    if(this.configuration.pathSuffix){
        this.getModel().pathSuffix(this.configuration.pathSuffix);
    }

    lib_core.Controller.prototype.beforeLoad.call(this);
};

TrayAssetSearchTabController.prototype.afterLoad = function() {
    var self = this;
    lib_core.Controller.prototype.afterLoad.call(this);

    //register this tab to parent tray tabs
    this.trayTabsController.registerTab(this.getModel());

    this.parent().getModel().activeTab.onChange("reloadOnTabChange", function(newTab){
        if(newTab.reload) newTab.reload();
    });
 
};

TrayAssetSearchTabController.prototype.createView = function () {
    return new TrayAssetSearchTabView(this.getModel(), this.getStatemachine(), this.rootStateMachine, this.trayTabsController.getView(), this.trayTabsController.name(), this.configuration);
};

TrayAssetSearchTabController.prototype.createModel = function () {
    return new TrayAssetSearchTabModel(this.rootStateMachine, this.root.dataLoader);
};

TrayAssetSearchTabController.prototype.createStateMachine = function () {
    var parentName = this.trayTabsController.name();
    return new TrayAssetSearchTabStateMachine(this.root, this.getModel(), parentName);
};
